const buildScreenActionBase = ({
    text,
    icon,
    qa,
    onClick = null,
    isVisible = true,
    isEnabled = true,
}) => ({
    key: qa,
    qa,
    fn: onClick,
    icon,
    isEnabled,
    buttonVisibility: isVisible,
    text,
    tooltipVisibility: false, // overridden in buildScreenButtonActionWithTooltip
});

/**
 * Builds a visible screen button action.
 * @param {string} text
 * @param {string} icon
 * @param {string} qa
 * @param {Function} onClick
 * @param {boolean} [isVisible=true]
 * @param {boolean} [isEnabled=true]
 * @param {Object} [props]
 * @returns {Object}
 */
export const buildScreenButtonAction = ({
    text,
    icon,
    qa,
    onClick,
    isVisible = true,
    isEnabled = true,
    props = {},
}) => ({
    ...buildScreenActionBase({
        text,
        icon,
        qa,
        onClick,
        isVisible,
        isEnabled,
    }),
    props: {
        icon,
        enabled: isEnabled,
        ...props,
    },
});

/**
 * Builds a screen button action with tooltip metadata.
 * @param {string} text
 * @param {string} icon
 * @param {string} qa
 * @param {Function} onClick
 * @param {boolean} [isTooltipVisible=false]
 * @param {string|null} [tooltipText=null]
 * @param {boolean} [isVisible=true]
 * @param {boolean} [isEnabled=true]
 * @param {Object} [props]
 * @returns {Object}
 */
export const buildScreenButtonActionWithTooltip = ({
    text,
    icon,
    qa,
    onClick,
    isTooltipVisible = false,
    tooltipText = null,
    isVisible = true,
    isEnabled = true,
    props = {},
}) => ({
    ...buildScreenButtonAction({
        text,
        icon,
        qa,
        onClick,
        isVisible,
        isEnabled,
        props,
    }),
    tooltipVisibility: isTooltipVisible,
    tooltipText,
});

/**
 * Builds a screen balloon menu action.
 * @param {string} text
 * @param {string} icon
 * @param {string} qa
 * @param {Function|null} [onClick=null]
 * @param {boolean} [isVisible=true]
 * @param {boolean} [isEnabled=true]
 * @param {Object|null} [to=null]
 * @param {string|null} [url=null]
 * @returns {Object}
 */
export const buildScreenBalloonAction = ({
    text,
    icon,
    qa,
    onClick = null,
    isVisible = true,
    isEnabled = true,
    to = null,
    url = null,
}) => ({
    ...buildScreenActionBase({
        text,
        icon,
        qa,
        onClick,
        isVisible,
        isEnabled,
    }),
    to,
    url,
});
